import AccountingLayout from '@/screens/accounting'
import Accounting from '@/screens/accounting/List'
import Purchases from '@/screens/accounting/purchases/List'

import auth from './middleware/auth'
import store from '@/store'

const routes = [
  {
    path: '/accounting',
    name: 'AccountingLayout',
    component: {
      ...AccountingLayout,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'AccountingLayout') {
          const routes = {
            manager: 'Accounting',
            chef: 'Accounting',
            buyer: 'Accounting'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'AccountingLayout') {
          const routes = {
            manager: 'Accounting',
            chef: 'Accounting',
            buyer: 'Accounting'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        path: 'accounting',
        name: 'Accounting',
        component: Accounting,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'chef'],
          middleware: { auth }
        }
      },
      {
        path: 'purchases',
        name: 'Purchases',
        component: Purchases,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'buyer'],
          middleware: { auth }
        }
      }
    ]
  }
]

export default routes
